import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../app-context';
import { getHourlyAdCostTrend } from '../amazon.services';
import { Grid} from '@mui/material';
import Chart from 'react-google-charts';
import IButton from '../../../components/button/i-button.component';
import IReadOnlyField from '../../../components/text-component/readonly-field/i-readonlyfield.component';
import { formatDate } from '../../common/util.services';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { DAYS_MONTH } from '../../common/constants';

const HourlyAdCostTrend = () => {
  const appContext = useContext(AppContext);
  const [trendData, setTrendData] = useState();
  const [startDate, setStartDate] = useState<any>(dayjs().subtract(DAYS_MONTH, 'day'));
  const [endDate, setEndDate] = useState<any>(dayjs());
  const [sDate, setSDate] = useState('');
  const [eDate, setEDate] = useState('');
  const options = { legend: {position: 'top', alignment: 'center'}, colors: ["blue", "purple"], 
                    tooltip: { trigger: "none" }, seriesType: "line", series: { 1: { type: "bars" }},
                    chartArea: {left: 50, right: 20, width: '100%'}, vAxes: {0:{viewWindow: { min: 0}}}};

  useEffect(() => {
    getData();
  }, []);

  function getData() {
    getHourlyAdCostTrend(startDate.format('YYYY-MM-DD'), endDate.format('YYYY-MM-DD'), appContext,
      (response: any) => {
        let adData: any = [["Period", "ACOS", { role: "annotation" }, "TACOS", { role: "annotation" }]];
        for(let i = 0; i < response.data.length; ++i) {
          let data: any = [response.data[i][0], +response.data[i][1], response.data[i][1],
                           +response.data[i][2], response.data[i][2]];
          adData.push(data);
        }
        setTrendData(adData);
        setSDate(formatDate(response.data[0][3]));
        setEDate(formatDate(response.data[0][4]));
        appContext.setShowLoader(false);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
      });
  };

  const search = (e: any) => {
    getData();
  }

  const startDatechange = (value: any) => {
    setStartDate(value);
  }

  const endDatechange = (value: any) => {
    setEndDate(value);
  }

  const getSearchComponent = () => {
    return <>
      <Grid container columnSpacing={3} sx={{ alignItems: 'center', justifyContent: 'center', gap: 1 }}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker slotProps={{ textField: { size: 'small' } }} format={'DD/MM/YYYY'} label={'Start Date'}
            value={startDate} onChange={startDatechange}/></LocalizationProvider>
        <LocalizationProvider dateAdapter={AdapterDayjs}> 
          <DatePicker slotProps={{ textField: { size: 'small' } }} format={'DD/MM/YYYY'} label={'End Date'}
            value={endDate} onChange={endDatechange}/></LocalizationProvider>
        <IButton label='Submit' onActionEvent={search}/>
        <Grid xs={12} sx={{ display: 'block', width: '100%', height: 0 }} />
        <IReadOnlyField label='Start Date' value={sDate}/>
        <IReadOnlyField label='End Date' value={eDate}/>
        <IReadOnlyField label='Days' value={dayjs(eDate).diff(dayjs(sDate), 'day') + 1}/>
      </Grid>
    </>
  }

  return <>
    <div style={{ width: '1200px', maxWidth: '100%', margin: '0 auto', boxSizing: 'border-box', padding: '0 8px' }}>
      {getSearchComponent()}
      <Chart chartType="ComboChart" height={"500px"} width="100%" data={trendData} options={options} legendToggle={true}/>
    </div>
  </>
}

export default HourlyAdCostTrend;

